import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Account, GetAccountResponse } from './types';
import { ACCOUNTS_TAG } from './constants';
import { Team } from '../teams';

export const accountsApi = createApi({
  reducerPath: 'accountsApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/accounts/' }),
  tagTypes: [ACCOUNTS_TAG],
  endpoints: (builder) => ({
    getAccount: builder.query<Account, void>({
      query: () => 'current/',
      transformResponse: (response: GetAccountResponse) => response.data,
      providesTags: [ACCOUNTS_TAG],
    }),
  }),
});

export async function updateAccountTeam(team: Team, dispatch: any) {
  await dispatch(
    accountsApi.util.updateQueryData('getAccount', undefined, (draft) => {
      if (draft) {
        const teams = draft.teams || {};
        const player = team.players.find(player => player.account_id === draft.spa_id);

        if (!player) return;

        teams[team.tournament_id] = {
          id: team.id,
          tag: team.tag,
          logo: team.logo,
          player_id: player.id,
          player_role: player.role,
          tournamentId: team.tournament_id,
        };
        draft.teams = teams;
      }
    })
  );
}

export async function removeAccountTeam(tournamentId: string, dispatch: any) {
  await dispatch(
    accountsApi.util.updateQueryData('getAccount', undefined, (draft) => {
      if (draft && draft.teams) {
        delete draft.teams[tournamentId];
      }
    })
  );
}

export const {
  useGetAccountQuery,
} = accountsApi;
